export default __webpack_public_path__ + "static/international-yards-desktop-5748d51b656560af3d76e064f7e3fe45.svg";